import {
  lazy,
  Suspense
} from "react";
import {
  Route,
  Routes
} from "react-router";

import { RequireAdmin } from "../components/admin/RequireAdmin";
import { AdminLayout } from "../layouts/AdminLayout";
import { StorefrontLayout } from "../layouts/StorefrontLayout";
import { HomePage } from "../pages/HomePage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { ProductDetailsPage } from "../pages/ProductDetailsPage";
import { ShopPage } from "../pages/ShopPage";
import { GiftHampersPage } from "../pages/GiftHampersPage";
import { IngredientsPage } from "../pages/IngredientsPage";
import { MakingRiniPage } from "../pages/MakingRiniPage";
import { OurStoryPage } from "../pages/OurStoryPage";
import { CartPage } from "../pages/CartPage";
import { OrderSuccessPage } from "../pages/OrderSuccessPage";
import { CheckoutPage } from "../pages/CheckoutPage";

const AdminDashboardPage = lazy(
  () =>
    import("../pages/AdminDashboardPage").then(
      (module) => ({
        default: module.AdminDashboardPage
      })
    )
);

const AdminLoginPage = lazy(
  () =>
    import("../pages/AdminLoginPage").then(
      (module) => ({
        default: module.AdminLoginPage
      })
    )
);

const AdminPlaceholderPage = lazy(
  () =>
    import("../pages/AdminPlaceholderPage").then(
      (module) => ({
        default: module.AdminPlaceholderPage
      })
    )
);

const AdminProductsPage = lazy(
  () =>
    import("../pages/AdminProductsPage").then(
      (module) => ({
        default: module.AdminProductsPage
      })
    )
);

const AdminCategoriesPage = lazy(
  () =>
    import("../pages/AdminCategoriesPage").then(
      (module) => ({
        default: module.AdminCategoriesPage
      })
    )
);

const AdminCategoryCreatePage = lazy(
  () =>
    import("../pages/AdminCategoryCreatePage").then(
      (module) => ({
        default: module.AdminCategoryCreatePage
      })
    )
);

const AdminCategoryEditPage = lazy(
  () =>
    import("../pages/AdminCategoryEditPage").then(
      (module) => ({
        default: module.AdminCategoryEditPage
      })
    )
);

const AdminProductCreatePage = lazy(
  () =>
    import("../pages/AdminProductCreatePage").then(
      (module) => ({
        default: module.AdminProductCreatePage
      })
    )
);

const AdminProductEditPage = lazy(
  () =>
    import("../pages/AdminProductEditPage").then(
      (module) => ({
        default: module.AdminProductEditPage
      })
    )
);


const AdminHomepagePage = lazy(
  () =>
    import("../pages/AdminHomepagePage").then(
      (module) => ({
        default:
          module.AdminHomepagePage
      })
    )
);

const AdminHomepageSectionsPage = lazy(
  () =>
    import("../pages/AdminHomepageSectionsPage").then(
      (module) => ({
        default:
          module.AdminHomepageSectionsPage
      })
    )
);

const AdminMakingRiniPage = lazy(
  () =>
    import("../pages/AdminMakingRiniPage").then(
      (module) => ({
        default:
          module.AdminMakingRiniPage
      })
    )
);


const AdminIngredientsPage = lazy(
  () =>
    import("../pages/AdminIngredientsPage").then(
      (module) => ({
        default:
          module.AdminIngredientsPage
      })
    )
);

const AdminIngredientCreatePage = lazy(
  () =>
    import("../pages/AdminIngredientCreatePage").then(
      (module) => ({
        default:
          module.AdminIngredientCreatePage
      })
    )
);

const AdminIngredientEditPage = lazy(
  () =>
    import("../pages/AdminIngredientEditPage").then(
      (module) => ({
        default:
          module.AdminIngredientEditPage
      })
    )
);


const AdminTestimonialsPage = lazy(
  () =>
    import("../pages/AdminTestimonialsPage").then(
      (module) => ({
        default:
          module.AdminTestimonialsPage
      })
    )
);

const AdminTestimonialCreatePage = lazy(
  () =>
    import("../pages/AdminTestimonialCreatePage").then(
      (module) => ({
        default:
          module.AdminTestimonialCreatePage
      })
    )
);

const AdminTestimonialEditPage = lazy(
  () =>
    import("../pages/AdminTestimonialEditPage").then(
      (module) => ({
        default:
          module.AdminTestimonialEditPage
      })
    )
);


const AdminInstagramPage = lazy(
  () =>
    import("../pages/AdminInstagramPage").then(
      (module) => ({
        default:
          module.AdminInstagramPage
      })
    )
);

const AdminInstagramCreatePage = lazy(
  () =>
    import("../pages/AdminInstagramCreatePage").then(
      (module) => ({
        default:
          module.AdminInstagramCreatePage
      })
    )
);

const AdminInstagramEditPage = lazy(
  () =>
    import("../pages/AdminInstagramEditPage").then(
      (module) => ({
        default:
          module.AdminInstagramEditPage
      })
    )
);

function RouteLoadingScreen() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-[#fffdf9] px-6">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-[#5e3b2c]/20 border-t-[#5e3b2c]" />

        <p className="mt-5 text-sm font-semibold text-[#746d65]">
          Loading RiNi...
        </p>
      </div>
    </div>
  );
}



const AdminGiftHampersPage = lazy(
  () =>
    import("../pages/AdminGiftHampersPage").then(
      (module) => ({
        default:
          module.AdminGiftHampersPage
      })
    )
);

import { AdminOrdersPage } from "../pages/AdminOrdersPage";

import { AdminInventoryPage } from "../pages/AdminInventoryPage";

import { AdminCustomersPage } from "../pages/AdminCustomersPage";

import { AdminSettingsPage } from "../pages/AdminSettingsPage";

export function AppRoutes() {
  return (
    <Suspense fallback={<RouteLoadingScreen />}>
      <Routes>
      <Route
        path="/admin/login"
        element={<AdminLoginPage />}
      />

      <Route element={<RequireAdmin />}>
        <Route
          path="/admin"
          element={<AdminLayout />}
        >
          <Route
            index
            element={<AdminDashboardPage />}
          />

          <Route
            path="homepage"
            element={<AdminHomepagePage />}
          />

          <Route
            path="homepage/sections"
            element={<AdminHomepageSectionsPage />}
          />

          <Route
            path="products"
            element={<AdminProductsPage />}
          />

          <Route
            path="inventory"
            element={<AdminInventoryPage />}
          />

          <Route
            path="products/new"
            element={<AdminProductCreatePage />}
          />

          <Route
            path="products/:id/edit"
            element={<AdminProductEditPage />}
          />

          <Route
            path="categories"
            element={<AdminCategoriesPage />}
          />

          <Route
            path="categories/new"
            element={<AdminCategoryCreatePage />}
          />

          <Route
            path="categories/:id/edit"
            element={<AdminCategoryEditPage />}
          />

          <Route
            path="ingredients"
            element={<AdminIngredientsPage />}
          />

          <Route
            path="ingredients/new"
            element={<AdminIngredientCreatePage />}
          />

          <Route
            path="ingredients/:id/edit"
            element={<AdminIngredientEditPage />}
          />

          <Route
            path="testimonials"
            element={<AdminTestimonialsPage />}
          />

          <Route
            path="testimonials/new"
            element={<AdminTestimonialCreatePage />}
          />

          <Route
            path="testimonials/:id/edit"
            element={<AdminTestimonialEditPage />}
          />

          <Route
            path="instagram"
            element={<AdminInstagramPage />}
          />

          <Route
            path="instagram/new"
            element={<AdminInstagramCreatePage />}
          />

          <Route
            path="instagram/:id/edit"
            element={<AdminInstagramEditPage />}
          />


          <Route
            path="gift-hampers"
            element={<AdminGiftHampersPage />}
          />

          <Route
            path="media"
            element={
              <AdminPlaceholderPage
                title="Media library"
                description="Manage product photographs, banners and thumbnails."
              />
            }
          />

          <Route
            path="videos"
            element={<AdminMakingRiniPage />}
          />

          <Route
            path="orders"
            element={<AdminOrdersPage />}
          />

          <Route
            path="customers"
            element={<AdminCustomersPage />}
          />

          <Route
            path="settings"
            element={<AdminSettingsPage />}
          />
        </Route>
      </Route>

      <Route element={<StorefrontLayout />}>
        <Route
          index
          element={<HomePage />}
        />

        <Route
          path="shop"
          element={<ShopPage />}
        />

        <Route
          path="cart"
          element={<CartPage />}
        />

        <Route
          path="checkout"
          element={<CheckoutPage />}
        />

        <Route
          path="order-success"
          element={<OrderSuccessPage />}
        />

        <Route
          path="gift-hampers"
          element={<GiftHampersPage />}
        />


        <Route
          path="our-story"
          element={<OurStoryPage />}
        />

        <Route
          path="ingredients"
          element={<IngredientsPage />}
        />

        <Route
          path="making-rini"
          element={<MakingRiniPage />}
        />

        <Route
          path="products/:slug"
          element={<ProductDetailsPage />}
        />

        <Route
          path="*"
          element={<NotFoundPage />}
        />
      </Route>
    </Routes>
  </Suspense>
  );
}
